// Types
export const topMainMenu = 'Top Main Menu';
export const topIconMenu = 'Top Icon Menu';
export const sliderNavBar = 'Slider Navbar';
export const breadcrumb = 'Breadcrumbs';
export const sectionTab = 'Section Tabs';
export const productDropdown = 'Product Dropdown';
export const footerMenu = 'Footer Menu';
export const marketSelector = 'Market Selector';
export const languageSelector = 'Language Selector';
export const quickLinks = 'Quick Links';
export const FindEquipment = 'Find Equipment Toolbar';
export const primaryCTA = 'Primary CTA';
export const secondaryCTA = 'Secondary CTA';
export const callTopService = 'Call Top Service';
export const newsLetter = 'Newsletter';

// Events
export const compatibleClickEvent = 'series_compatible_click';
export const specsExpandEvent = 'series_specs_expand';
export const specsExportEvent = 'series_specs_export';
export const downloadBrochures = 'series_brochures_download';
export const seriesNextStepsVisible = 'series_next_steps_visible';
export const modelNextStepsVisible = 'model_next_steps_visible';
export const seriesNextStepsClick = 'series_next_steps_click';
export const modelNextStepsClick = 'model_next_steps_click';
export const seriesFeatureDetailOpen = 'series_features_detail_open';
export const seriesMediaGalleryClick = 'series_media_gallery_click';
export const seriesOverviewCtaClick = 'series_overview_cta_click';
export const modelFeaturesVisible = 'model_features_visible';
export const modelFeaturesCTAOpen = 'model_feature_detail_open';
export const modelSpecsExport = 'model_specs_export';
export const modelSpecsExpand = 'model_specs_expand';
export const modelSpecsVisible = 'model_specs_visible';
export const modelMediaGalleryVisible = 'model_media_gallery_visible';
export const modelMediaGalleryClick = 'model_media_gallery_click';
export const modelCompatableAttachmentsVisible = 'model_compatible_attachments_visible';
export const lineSpecialOffersVisible = 'line_special_offers_visible';
export const seriesSpecialOffersVisible = 'series_special_offers_visible';
export const lineSpecialOffersClick = 'line_special_offers_click';
export const seriesSpecialOffersClick = 'series_special_offers_click';
export const modelOverviewVisible = 'model_overview_visible';
export const modelOverviewCtaClick = 'model_overview_cta_click';
export const lineSeriesVisible = 'line_series_visible';
export const lineBrochuresVisible = 'line_brochures_visible';
export const brochuresDownload = 'file_download';
export const lineTestimonialsVideoPlay = 'line_testimonials_video_play';
export const lineTestimonialsVisible = 'line_testimonials_visible';
export const modelFeatureDetailOpen = 'model_feature_detail_open';
export const homeProductSelectorLineVisible = 'home_product_selector_line_visible';
export const homeProductSelectorSeriesClick = 'home_product_selector_series_click';
export const lineSeriesClick = 'line_series_click';
export const dealerLocatorResultsOpen = 'dealer_locator_results_open';
export const dealerLocatorGeolocationClick = 'dealer_locator_geolocation_click';
export const dealerLocatorGetDirections = 'dealer_locator_get_directions';
export const dealerLocatorDetailView = 'dealer_locator_detail_view';
export const dealerLocatorContactClick = 'dealer_locator_contact_click';
